<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div class="section operations" style="height: 39px;">
          <div class="triggers">
            <div>
              <span style="display: inline-block;width: 90px;color: #333333">{{ $t('CargoMsg.Cargo_Months') }}</span>
              <el-input-number
                v-model="currentMonth"
                no="currentMonth"
                controls-position="right"
                :disabled="isCopySave"
                style="margin-right: 5px;"
                @change="handleChange"
                @keyup.enter.native="handleNativeChange"
              />
              <span v-if="isCopySave">
                <el-button no="copySave" type="primary" @click="copySace">{{ $t('common.btn.save') }}</el-button>
                <el-button no="copyCancel" type="primary" @click="copyCancel">{{ $t('common.btn.cancel') }}</el-button>
              </span>
              <span v-else>
                <el-upload
                  no="saveExcelFile"
                  :action="url.mdm.rate.saveExcelFile"
                  :headers="{sessionId}"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeUpload"
                  :on-success="uploadSuccess"
                  style="display: inline-block;"
                >
                  <el-button v-if="$checkPermission(['write_SMRate'])" no="excelImport" type="primary">{{ $t('SeaExport.ExcelImport') }}</el-button>
                </el-upload>
                <el-button v-if="$checkPermission(['write_SMRate'])" no="new" type="primary" @click="popRateManagementAddFormDialog">
                  {{ $t('common.btn.new') }}
                </el-button>
                <el-button v-if="$checkPermission(['write_SMRate'])" no="edit" type="primary" @click="popRateManagementEditFormDialog">
                  {{ $t('common.btn.edit') }}
                </el-button>
                <el-button v-if="$checkPermission(['role_SMRate_copy'])" no="copyRate" type="primary" @click="popRateManagementCopyFormDialog">{{ $t('baseInfo.rateManagement.copyRate') }}
                </el-button>
                <el-button v-if="$checkPermission(['role_SMRate_remove'])" no="delete" type="danger" @click="toDelete">{{ $t('common.btn.delete') }}</el-button>
                <el-button v-if="isAdmin" no="setRateCacheRange" type="primary" @click="setRateCacheRange">{{ $t('baseInfo.rateManagement.setRateCacheRange') }}</el-button>
                <el-button v-if="$checkPermission(['write_SMRate'])" no="updateChargeRatesByEtdMonth" type="primary" @click="updateChargeRatesByEtdMonthHandler">
                  {{ $t('CargoMsg.Cargo_UpdateExchangeRate') }}
                </el-button>
                <el-button no="excelExport" type="primary" @click="exportHandler">{{ $t('SeaExport.ExcelExport') }}</el-button>
              </span>
              <label v-if="!isMaintainEdit" style="color:#BBBBBB;margin-left: 15px">
                {{ showRateRatio }}
              </label>
            </div>
          </div>
        </div>
        <div class="section grid-wrapper" style="min-height:350px">
          <cargo-ag-grid
            no="grid"
            config-module="100501"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
      </div>
    </div>
    <!-- 费率维护 -->
    <el-dialog
      slot="reference"
      v-el-drag-dialog
      no="rateMaintain"
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="showMaintain"
      :title="$t('baseInfo.rateManagement.rateMaintain')"
      inline-message
      width="405px"
    >
      <el-form ref="rateManagementForm" :model="rateManagementForm" label-width="130px" label-position="right">
        <el-form-item :label="$t('baseInfo.rateManagement.currency')">
          <cargo-advance-select
            no="currency"
            :select-type="selectTypeNames.basic_data_Currency"
            :callback-params="{key:'currency'}"
            callback-method-type="value"
            :default-value="rateManagementForm.currency"
            filterable
            style="width:205px;"
            @parentCallBack="selectCargoItem"
          />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.rateManagement.baseCuurency')">
          <cargo-advance-select
            no="baseCurrency"
            :select-type="selectTypeNames.basic_data_Currency"
            :callback-params="{key:'baseCuurency'}"
            callback-method-type="value"
            :default-value="rateManagementForm.baseCuurency"
            filterable
            :clearable="false"
            style="width:205px;"
            @parentCallBack="selectCargoItem"
          />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.rateManagement.rate')">
          <el-input
            v-stopNumberMousewheel
            :value="rateManagementForm.rate"
            no="rate"
            type="number"
            style="width: 130px;"
            @input="onRateInput"
            @change="onRateChange"
          />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.rateManagement.month')" prop="month">
          <el-input v-model="rateManagementForm.month" no="month" disabled />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button no="save" type="primary" @click="submitRateManagement">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 复制利率 -->
    <el-dialog
      slot="reference"
      v-el-drag-dialog
      no="copyRateMaintain"
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="showCopyMaintain"
      :title="$t('baseInfo.rateManagement.copyRateMaintain')"
      inline-message
      width="400px"
    >
      <el-form :inline="true" label-width="90px" label-position="left">
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('CargoMsg.Cargo_Months')">
            <el-input-number
              v-model="copyCurrentMonth"
              no="copyCurrentMonth"
              controls-position="right"
              @change="copyHandleChange"
            />
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button no="submitCopyRateManagement" type="primary" @click="submitCopyRateManagement">{{ $t('common.btn.save') }}
        </el-button>
        <el-button no="cancelCopySaveOrEdit" @click="cancelCopySaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <rate-cache-range-dialog :visible.sync="maintainRateCacheRangeControl" />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import URL from '@/api/urlTranslator'

import { getRateList, batchDelRate, updateRate, addRate, copyRate, confirmCopyRate } from '@/api/rate'
import { updateChargeRatesByEtdMonth } from '@/api/clearing/charge'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getGridSelectedIds, getGridSelected } from '@/utils/agGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import lodash from 'lodash'
import { getToken } from '@/utils/auth'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { syncSpecificBasicData } from '@/utils/basicDataCache'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { isNumber } from '@/utils/validate'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import RateCacheRangeDialog from '@/views/cargo/v0/Information/RateCacheRangeDialog.vue'

export default {
  name: 'BillingRate',
  components: { RateCacheRangeDialog, cargoAdvanceSelect },
  data() {
    return {
      sessionId: getToken(),
      loading: false,
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      columnDefs: [
        {
          headerName: '', checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('baseInfo.rateManagement.originalCurrency'),
          field: 'currency'
        }, {
          headerName: this.$t('baseInfo.rateManagement.benchmarkCurrency'),
          field: 'baseCuurency'
        }, {
          headerName: this.$t('baseInfo.rateManagement.rate'),
          field: 'rate',
          cellRenderer: (params) => {
            return params.value ? this.$numeral(params.value).format('0,0.00000000') : ''
          }
        }, {
          headerName: this.$t('baseInfo.rateManagement.effectiveMonth'),
          field: 'month'
        }],
      rowData: [],
      copyRowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          // resizable: true,
          filter: true
        },
        pagination: false,
        onRowClicked: this.onRowCLick,
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
          if (nodes && nodes.length > 0) {
            this.setShowRateRatio(nodes[0].data)
          }
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        }
      },
      selectedNode: null,
      currentMonth: '',
      copyCurrentMonth: '',
      showMaintain: false,
      showCopyMaintain: false,
      isMaintainEdit: false,
      initRateManagementForm: {
        uuid: '',
        tenantId: '',
        baseCuurency: 'RMB',
        currency: '',
        rate: '0.00000000',
        month: 1,
        version: ''
      },
      rateManagementForm: {},
      originBaseCuurency: '',
      originCurrency: '',
      showRateRatio: '',
      isCopySave: false,
      maintainRateCacheRangeControl: false
    }
  },
  computed: {
    url() {
      return URL
    },
    computeCurrentMonth() {
      const date = new Date()
      return date.getFullYear() + (date.getMonth() + 1).toString().padStart(2, '0')
    },
    isAdmin() {
      return this.$store.getters.isAdmin
    }
  },
  mounted() {
    // 初始化当前月份
    this.currentMonth = this.computeCurrentMonth
    this.fetchRateList()
  },
  methods: {
    handleChange(value) {
      value = value + ''
      this.currentMonth = this.generationMonth(value)
      this.copyCurrentMonth = this.generationLastMonth(value)
      this.fetchRateList()
      if (!this.isMaintainEdit) {
        this.rateManagementForm.month = this.currentMonth
      }
    },
    handleNativeChange() {
      this.currentMonth = this.generationMonth(this.currentMonth)
      this.copyCurrentMonth = this.generationLastMonth(this.currentMonth)
      this.fetchRateList()
      if (!this.isMaintainEdit) {
        this.rateManagementForm.month = this.currentMonth
      }
    },
    copyHandleChange(value) {
      value = value + ''
      this.copyCurrentMonth = this.generationMonth(value)
      this.fetchCopyRateList()
    },
    // 生成月份 格式yyyyMM
    generationMonth(value) {
      if (value) {
        // 获取月份
        let year = value.slice(0, 4)
        // 获取年份
        let month = value.slice(4)

        if (month > 12) {
          year = Number(year) + 1
          month = '01'
        }
        if (month <= 0) {
          year = Number(year) - 1
          month = '12'
        }
        return year + month
      }
      return ''
    },
    // 生成月份 格式yyyyMM
    generationLastMonth(value) {
      if (value) {
        // 获取月份
        let year = value.slice(0, 4)
        // 获取年份
        let month = value.slice(4)
        month = month - 1
        if (month <= 0) {
          year = Number(year) - 1
          month = '12'
        } else {
          month = this.prefixInteger(month, 2)
        }
        return year + month
      }
      return ''
    },
    onRateInput(value) {
      // 非数字
      if (/[^0-9.]/.test(value)) {
        return
      }
      // indexOf、lastIndexOf的返回值分三种情况：
      // 1、没有“.”，都是-1（相等）
      // 2、有一个“.”，都是同一个值（相等）
      // 3、有两个及以上的“.”，值不一样（不相等）
      if (value.indexOf('.') !== value.lastIndexOf('.')) {
        return
      }
      this.rateManagementForm.rate = value
    },
    onRateChange(value) {
      if (isNumber(value)) {
        this.rateManagementForm.rate = Number(CurrencyUtil.truncateRateByCurrency(this.rateManagementForm.currency, value)).toFixed(8)
      } else {
        this.rateManagementForm.rate = '0.00000000'
      }
    },
    // 获取费率列表
    fetchRateList() {
      const self = this
      const params = {
        currentYearMonth: this.currentMonth
      }
      getRateList(params).then(res => {
        self.rowData = res.data
        if (self.rowData.length <= 0) {
          this.showRateRatio = ''
        }
      }).catch(() => {
      })
    },
    async updateChargeRatesByEtdMonthHandler() {
      try {
        await this.$confirm(this.$t('CargoMsg.Cargo_ConfirmUpdateExchangeRate'), this.$t('common.tips.confirm'), { type: 'warning' })
      } catch (e) {
        return
      }
      const data = {
        branchId: this.$store.getters.currentOfficeId,
        etdMonth: this.currentMonth
      }
      this.loading = getLoading()
      updateChargeRatesByEtdMonth(data).then(() => {
        this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
      }).catch(() => {
      }).finally(() => {
        this.loading.close()
      })
    },
    setShowRateRatio(data) {
      if (data) {
        this.showRateRatio = '1 ' + data.currency + '= ' + this.$numeral(data.rate).format('0,0.00000000') + data.baseCuurency
      } else {
        this.showRateRatio = ''
      }
    },
    // 获取复制费率列表
    fetchCopyRateList() {
      const self = this
      const params = {
        currentYearMonth: this.copyCurrentMonth
      }
      getRateList(params).then(res => {
        self.copyRowData = res.data
      }).catch(() => {
      })
    },
    popRateManagementAddFormDialog() {
      this.rateManagementForm = { ...this.initRateManagementForm }
      this.rateManagementForm.month = this.currentMonth
      this.isMaintainEdit = false
      this.showMaintain = true
    },
    setRateCacheRange() {
      this.maintainRateCacheRangeControl = true
    },
    popRateManagementCopyFormDialog() {
      // 初始化当前月份
      this.copyCurrentMonth = this.generationLastMonth(this.currentMonth + '')
      this.fetchCopyRateList()
      this.showCopyMaintain = true
    },
    popRateManagementEditFormDialog() {
      const self = this
      getGridSelectedIds(this.gridOptions).then(ids => {
        if (ids.length !== 1) {
          this.$message.error(this.$t('common.tips.hasOneAtleast'))
        } else {
          self.rateManagementForm = { ...getGridSelected(this.gridOptions)[0] }
          self.originBaseCuurency = self.rateManagementForm.baseCuurency
          self.originCurrency = self.rateManagementForm.currency
          self.isMaintainEdit = true
          self.showMaintain = true
          self.rateManagementForm.rate = self.rateManagementForm.rate ? this.$numeral(self.rateManagementForm.rate).format('0.00000000') : ''
        }
      })
    },
    // 删除
    toDelete() {
      const self = this
      getGridSelectedIds(this.gridOptions, 'uuid').then(async ids => {
        if (ids.length !== 1) {
          self.$message.error(self.$t('common.tips.hasOneOnly'))
        } else {
          await self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.confirm'), { type: 'warning' })
          self.loading = getLoading()
          batchDelRate(ids).then(() => {
            self.fetchRateList()
            self.$message.success(self.$t('common.tips.deleteSuccess'))
          }).finally(() => {
            self.loading.close()
          })
        }
      })
    },
    getRateManagementSelected() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length <= 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return null
      }
      return selectedRows
    },
    submitRateManagement() {
      if (!this.toCheckRateForm(this.rateManagementForm)) {
        return
      }
      if (!this.isMaintainEdit) {
        this.toAddRateManagement()
      } else {
        // 复制利率进行编辑
        if (this.isCopySave) {
          for (let i = 0; i < this.rowData.length; i++) {
            if (this.rowData[i]['uuid'] === this.rateManagementForm.uuid) {
              this.rowData[i]['currency'] = this.rateManagementForm.currency
              this.rowData[i]['baseCuurency'] = this.rateManagementForm.baseCuurency
              this.rowData[i]['rate'] = this.rateManagementForm.rate
              // type为空 那就赋值以后 type 2
              if (!this.rateManagementForm.type) {
                this.rowData[i]['type'] = 2
              }
            }
          }
          this.showMaintain = false
          const params = {
            force: true
          }
          this.gridOptions.api.refreshCells(params)
        } else {
          this.isMaintainEdit = false
          this.toEditRateManagement()
        }
      }
    },
    // 检查汇率表单
    toCheckRateForm(opt) { // opt=> add,edit
      const { currency, rate } = opt
      let errorMsg = ''
      if (!currency) {
        errorMsg += this.$t('baseInfo.rateManagement.currencyCheck')
      }
      if (!rate) {
        errorMsg += this.$t('baseInfo.rateManagement.rateCheck')
      }
      // 汇率长度限制
      const rateLength = this.rateManagementForm.rate.split('.')[0].length
      if (rateLength.length > 6) {
        errorMsg += this.$t('baseInfo.rateManagement.rateIsTooLong')
      }
      let duplicated = false
      if (!this.isMaintainEdit) {
        if (this.hasDuplicate({ ...this.rateManagementForm })) {
          errorMsg += this.$t('baseInfo.rateManagement.repeatCheck2').format(this.rateManagementForm.currency, this.rateManagementForm.baseCuurency)
          duplicated = true
        }
      }
      if (!duplicated && !(this.isMaintainEdit && this.originBaseCuurency === this.rateManagementForm.baseCuurency && this.originCurrency === this.rateManagementForm.currency)) {
        if (this.hasDuplicate({ ...this.rateManagementForm })) {
          errorMsg += this.$t('baseInfo.rateManagement.repeatCheck2').format(this.rateManagementForm.currency, this.rateManagementForm.baseCuurency)
        }
      }
      if (errorMsg) {
        this.$message.warning(errorMsg)
        return
      } else {
        return true
      }
    },
    // 编辑汇率
    toEditRateManagement() {
      updateRate(this.rateManagementForm).then(res => {
        this.showMaintain = false
        this.$message({ message: this.$t('common.tips.editSuccess'), type: 'success' })
      }).then(() => {
        this.fetchRateList()
      })
    },
    // 新增汇率
    toAddRateManagement() {
      addRate(this.rateManagementForm).then(res => {
        this.showMaintain = false
        this.$message({ message: this.$t('common.tips.saveSuccess'), type: 'success' })
      }).then(() => {
        this.fetchRateList()
      })
    },
    // 取消保存或者编辑
    cancelSaveOrEdit() {
      this.rateManagementForm = { ...this.initRateManagementForm }
      this.showMaintain = false
      this.isMaintainEdit = false
    },
    // 验证是否存在重复的配置
    hasDuplicate(rateManagementObj) {
      if (this.rowData.length > 0) {
        for (let i = 0; i < this.rowData.length - 1; i++) {
          if (rateManagementObj['currency'] === this.rowData[i]['currency'] && rateManagementObj['baseCuurency'] === this.rowData[i]['baseCuurency']) {
            return true
          }
        }
      }
      return false
    },
    // 检查复制汇率表单
    toCheckCopyRateForm() {
      let errorMsg = ''
      if (this.copyCurrentMonth === this.currentMonth) {
        errorMsg += this.$t('baseInfo.rateManagement.copyCurrentMonthCheck')
      }
      if (this.copyRowData.length <= 0) {
        errorMsg += this.$t('baseInfo.rateManagement.copyRowDataCheck')
      }
      if (!errorMsg) {
        return true
      }
      this.$message.error(errorMsg)
    },
    // 提交复制汇率
    submitCopyRateManagement() {
      if (!this.toCheckCopyRateForm()) {
        return
      }
      const self = this
      const params = {
        currentYearMonth: this.currentMonth,
        copyCurrentYearMonth: this.copyCurrentMonth
      }
      // 确认是否有相同汇率
      confirmCopyRate(params).then(res => {
        this.isCopySave = true
        this.showCopyMaintain = false
        if (res.data['waitUpdate'].length > 0) {
          this.$confirm(this.$t('Information.WhetherToOverwriteExistingData'), this.$t('Information.Overwrite'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            closeOnClickModel: false,
            type: 'warning'
          }).then(() => {
            let array = []
            if (res.data['waitAdd'].length > 0) {
              for (let i = 0; i < res.data['waitAdd'].length; i++) {
                res.data['waitAdd'][i].month = this.currentMonth
                res.data['waitAdd'][i].type = 1
              }
              array = array.concat(res.data['waitAdd'])
            }

            array = array.concat(this.rowData)
            if (res.data['waitUpdate'].length > 0) {
              const updateArray = res.data['waitUpdate']
              for (let i = 0; i < array.length; i++) {
                for (let j = 0; j < updateArray.length; j++) {
                  if (array[i].baseCuurency === updateArray[j].baseCuurency && array[i].currency === updateArray[j].currency) {
                    array[i].rate = updateArray[j].rate
                    array[i].month = this.currentMonth
                    array[i].type = 2
                  }
                }
              }
            }
            this.rowData = array
            const params = {
              force: true
            }
            this.gridOptions.api.refreshCells(params)
          }).catch(() => {
            let array = []
            if (res.data['waitAdd'].length > 0) {
              for (let i = 0; i < res.data['waitAdd'].length; i++) {
                res.data['waitAdd'][i].month = this.currentMonth
                res.data['waitAdd'][i].type = 1
              }
              array = array.concat(res.data['waitAdd'])
            }
            array = array.concat(this.rowData)
            this.rowData = array
            const params = {
              force: true
            }
            this.gridOptions.api.refreshCells(params)
          })
        } else {
          let array = []
          if (res.data['waitAdd'].length > 0) {
            for (let i = 0; i < res.data['waitAdd'].length; i++) {
              res.data['waitAdd'][i].month = this.currentMonth
              res.data['waitAdd'][i].type = 1
            }
            array = array.concat(res.data['waitAdd'])
          }
          array = array.concat(this.rowData)
          this.rowData = array
          const params = {
            force: true
          }
          this.gridOptions.api.refreshCells(params)
          const copyParams = {
            currentYearMonth: this.currentMonth,
            copyCurrentYearMonth: this.copyCurrentMonth,
            sysFxRateList: this.rowData
          }
          copyRate(copyParams).then(res => {
            self.copyRowData = res.data
            self.showCopyMaintain = false
            self.isCopySave = false
            self.$message({ message: this.$t('baseInfo.rateManagement.copyRateSuccess'), type: 'success' })
          }).then(() => {
            self.fetchRateList()
          }).catch(() => {
          })
        }
      })
    },
    // 取消复制汇率
    cancelCopySaveOrEdit() {
      this.showCopyMaintain = false
    },
    selectCargoItem(item) {
      this.rateManagementForm[item.key] = item.value
    },
    exportExcel() {
      const self = this
        import('@/vendor/Export2Excel').then(excel => {
          const tHeader = [
            self.$t('baseInfo.rateManagement.originalCurrency'),
            self.$t('baseInfo.rateManagement.benchmarkCurrency'),
            self.$t('baseInfo.rateManagement.rate'),
            self.$t('baseInfo.rateManagement.effectiveMonth')
          ]
          const filterVal = ['currency', 'baseCuurency', 'rate', 'month']
          const data = self.formatJson(filterVal, [])
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: 'Rate'
          })
        })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    onRowCLick(event) {
      if (this.gridOptions.api) {
        const rate = event.data
        if (rate) {
          this.showRateRatio = '1 ' + rate.currency + '= ' + this.$numeral(rate.rate).format('0,0.00000000') + ' ' + rate.baseCuurency
        }
      }
    },
    copySace() {
      const params = {
        sysFxRateList: this.rowData
      }
      copyRate(params).then(res => {
        self.copyRowData = res.data
        this.isCopySave = false
        this.$message({ message: this.$t('baseInfo.rateManagement.copyRateSuccess'), type: 'success' })
      }).then(() => {
        this.fetchRateList()
      }).catch(() => {
      })
    },
    copyCancel() {
      this.isCopySave = false
      this.fetchRateList()
    },
    prefixInteger(num, length) {
      return (Array(length).join('0') + num).slice(-length)
    },
    exportHandler() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      const self = this
      if (selectedRows.length === 0) {
        self.$message.warning(this.$t('Information.PleaseDataYouWantExport'))
        return
      }
      const rows = lodash.cloneDeep(selectedRows)
      var timestamp = new Date().getTime()
      console.log('====开始时间======', timestamp)
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      // 获取选中行
      const fileName = 'RateList.xls'
      exportExcel(fileName, rows, allDisplayedColumns, true)
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('Information.TheOnlyBeXlsFormat'))
      }
      if ((Math.round(file.size * 100 / (1024 * 1024)) / 100) > 2) {
        this.$message.warning(this.$t('Information.FileBeLargerThan2MB'))
        return false
      }
      return extension || extension2
    },
    uploadSuccess(response, file, fileList) {
      if (response) {
        if (response.code === '0') {
          this.onImportSucceeded(response.data)
        } else {
          this.onImportFailed(response)
        }
      } else {
        this.$message.warning(this.$t('Information.ImportPleaseContactTheAdministrator'))
      }
    },
    onImportSucceeded(msg) {
      if (msg.split(':').length > 2) {
        // 一个Excel中有多个sheet包含数据
        msg = msg.replace('records.', this.$t('Information.Items'))
        msg = this.$t('Information.recordsImportedIntoTheSystem').replace('@records', '\n' + msg + '\n\t')
      } else {
        // 仅一个sheet
        msg = msg.replace('records.', this.$t('Information.Items2'))
        msg = msg.split(':')[1]
        msg = this.$t('Information.recordsImportedIntoTheSystem').replace('@records', msg)
      }
      this.onSaveSucceed()
      this.$message.success(msg)
    },
    onImportFailed(info) {
      let msg = ''
      if (info.code === '531603') {
        const data = JSON.parse(info.message)
        // 1为导入的Excel中数据之间有重复 2为导入的Excel中数据与表中已有数据重复
        if (data.repeatType === '1') {
          msg = this.$t('Information.DuplicateBaseCurrencyValueExcel', [data.currency, data.baseCurrency])
        } else if (data.repeatType === '2') {
          msg = this.$t('Information.DuplicateCurrencyValue0Table', [data.currency, data.baseCurrency])
        } else {
          msg = this.$t('Information.DataExistingDataInTable')
        }
        // if (info.code === '30005') {
        //   const fd = info.extendedData.Field
        //   const val = info.extendedData.Value
        //   if (!(StrUtils.isEmpty(fd) || StrUtils.isEmpty(val))) {
        //     const msg_cn = '@key值为\'' + val + '\'与表中已有数据重复！'
        //     const fields = [['ENGLISH_NAME', '英文名', 'EnglishName'], ['CHINESE_NAME', '中文名', 'ChineseName']]
        //     let flag = false
        //     for (let i = fields.length - 1; i >= 0; i--) {
        //       if (fd.toUpperCase() === fields[i][0]) {
        //         msg = msg_cn.replace('@key', fields[i][1])
        //         flag = true
        //         break
        //       }
        //     }
        //     if (!flag) {
        //       msg = '值为\'' + val + '\'与表中已有数据重复！'
        //     }
        //   } else {
        //     msg = info.message.extendedData.ErrorMessage
        //   }
      } else {
        msg = info.message
        const index = msg.indexOf('1')
        if (index > -1) msg = msg.substr(index)
      }
      this.$message.error(msg)
    },
    onSaveSucceed() {
      syncSpecificBasicData(basicCacheKeys.basic_data_FxRate)
      // CacheManager.getInstance().loadCache('Rate')
      this.currentMonth = this.computeCurrentMonth
      this.fetchRateList()
    }
  }
}
</script>
